import { render, staticRenderFns } from "./BankAccountCreationModal.vue?vue&type=template&id=7264913d&scoped=true&"
import script from "./BankAccountCreationModal.vue?vue&type=script&lang=ts&"
export * from "./BankAccountCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264913d",
  null
  
)

export default component.exports